import { Time } from "@angular/common";

export class DBQDoctorModel {
  id?: number;
  salutationId?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  password?: string;
  isDeleted?: boolean = false;
  isActive?: boolean = true;
  totalRecords?: number;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  doctorAvailability?: DBQDoctorAvailabilityModel[];
  doctorSetting?: DBQDoctorGlobalSettingModel;
  assignedSpecialities?: [];
  lat?: number;
  long?: number;
  createdOn? : Date;
}

export interface SalutationModel {
  id: number;
  name: string;
}

export class DBQDoctorGlobalSettingModel {
  id: number;
  dbqDoctorId: number;
  initialSessionCost: number;
  initialSessionDuration: number;
  followupSessionCost: number;
  followupSessionDuration: number;
  appointmentCancellationGracePeriod: number;
}

export class DBQDoctorAvailabilityModel {
  id: number;
  dbqDoctorId: number;
  startDate?: Date;
  endDate?: Date;
  startTime?: Time;
  endTime?: Time;
  title?: string;
}

export interface DoctorSpeciality {
  id: number;
  speciality: string;
}

export class DBQPatientInviteModel {
  id: number;
  dbqPatientId: number;
  doctorSpecialityId: number;
  doctorSpeciality?: string;
  bookAppointmentURL?: string;
  isConfirmedByPatient?: boolean;
  totalRecords?: number;
}

export class DBQDoctorAppointmentModel {
  id?: number;
  dbqDoctorId: number;
  dbqPatientId: number;
  startDate?: Date;
  endDate?: Date;
  appointmentTime?: number;
  statusId?: number;
  dbqPatientInviteId: number;
  totalRecords?: number;
  status?: string;
  patientDisplayName?: string;
  patientEmail?: string;
  patientPhoneNumber?: string;
  appointmentDisplayDate?: string;
  appointmentInviteBy?: string;
  createdOn?: Date;

}

export class DBQDoctorAppointmentTimeModel {
  id: number;
  time: string;
}

export class DBQPatientModel {
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  isDeleted?: boolean = false;
  isActive?: boolean = true;
  totalRecords?: number;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  patientInvites?: DBQPatientInviteModel[]
  PatientDoctorAppointments?: DBQDoctorAppointmentModel[];
  lat?: number;
  long?: number;
  createdOn?: Date;
  
}

export class DBQDoctorAppointmentStatusUpdateModel {
  id: number;
  statusId: number;
}
